<template>
    <div class="fliter-item">
        <i class="count">{{count}}</i>
        <a class="cut-text">
            <template v-if="isShowCheckbox">
               <el-checkbox v-model="isChecked" @change="handleChange">
                    <span :title="title"><img v-if="showImg && imgObj.url" :src="imgObj.url" :alt="imgObj.name">{{title}}</span>
                </el-checkbox>
            </template>
            <template v-else>
                <span :title="title"><img v-if="showImg && imgObj.url" :src="imgObj.url" :alt="imgObj.name">{{title}}</span>
            </template>    
        </a>
    </div>
</template>

<script>
import countryAndAreaOptions from '../../data-range/src/countryAndAreaOptions'
export default {
    name:'ipFilterItem',
    props:{
        title:{type:String,default:''},
        value:{type:String,default:''},
        count:{type:Number,default:0},
        showImg:{type:Boolean,default:false},
        checked:{type:Boolean,default:false},
        isShowCheckbox:{type:Boolean,default:true}
    },
    data(){
        return{ 
            imgObj:{},
            isChecked:false
        }
    },
    watch:{
        checked(nv,ol){
             this.isChecked = nv;
        }
    },
    mounted(){
        this.isChecked = this.checked;
        if(this.showImg && this.value){
            this.imgObj = countryAndAreaOptions.get(this.value);
            if(this.showImg && this.imgObj.imgNo){
                this.imgObj.url = require('../../../../public/image/country/country' + this.imgObj.imgNo + '.jpg')
            }
        }
    },
    methods:{  
        handleChange(){
            this.$emit('change-filter-item',this.isChecked);
        }
    }
}
</script>

<style lang="scss" scoped>
.fliter-item{
    padding: 4px 0;
    position: relative;
    img{
        vertical-align: middle;
        margin-right: 5px;
    }
    .count{
        float: right;
        font-style: normal;
        font-size: $xs-font-size;
        padding: 0 10px 0 8px;
    }
    .cut-text{
        display: block;
        padding: 0 15px;
        text-decoration: none;
        overflow: hidden;
        white-space: nowrap;
        color: #333;
    }
}
</style>

